<template>
	<c-dialog ref="dialog" title="订单列表" width="1200"button-name="关闭" :cancel-button="false">
		<m-search ref="search" @search="search">
			<c-form ref="form" inline>
                <c-form-item type="input" label="订单号" name="order_number"></c-form-item>
                <c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
                <c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
                <c-form-item type="checkbox" label="订单状态" name="order_state" :options="orderState"></c-form-item>
            </c-form>
		</m-search>
			
		<c-table ref="table" height="400">
            <c-table-column
                label="订单号"
                name="order_number"
                width="100"
            >
                <template v-slot="{data}">
                    <a class="s-link" style="text-decoration: underline;" @click="navigateTo(`/order_detail/${data.order_number}`)">{{data.order_number}}</a>
                </template>
            </c-table-column>

            <c-table-column
                    label="订单状态"
                    name="order_state"
                    width="120"
            >
                <template v-slot="{data}">
                    <span v-if="data.order_state == 6" style="color:#999">
                        {{orderStateName[data.order_state]}}
                        <span v-if="data.cancel_reason_type_id<=0 && data.cancel_reason_type_name">({{data.cancel_reason_type_name}})</span>
                    </span>
                    <span v-else-if="data.check_state==1 || data.check_state==3" style="color:#182eff">{{orderStateName[data.order_state]}}</span>
                    <span v-else-if="data.check_state==2">
							<span v-if="data.refund_flag == 1" style="color: #ff5555">退款中({{data.refund_count}})</span>
							<span v-else-if="data.return_flag == 1" style="color: #ff5555">退货中({{data.return_count}})</span>
							<span v-else>
								<span v-if="data.payment_state == 2" style="color:#708fff">待付尾款</span>
								<span v-else>
									<span v-if="data.order_state == 1" style="color:#888888">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 2">
                                        {{orderStateName[data.order_state]}}
                                    </span>
									<span v-if="data.order_state == 3" style="color:#69d39c">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 5" style="color:darkgreen">{{orderStateName[data.order_state]}}</span>
								</span>
							</span>
							<span v-if="data.order_state==3 && data.deliver_state=='部分发货'"><br/> (<span style="color:dodgerblue">{{ data.deliver_state}}</span>)</span>
						</span>
                </template>
            </c-table-column>

            <c-table-column
                label="下单会员"
                name="head_photo"
                width="200"
            >
                <template v-slot="{data}">
                    <div class="flex-center-cross">
                        <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                        <span>{{data.nick_name||'--'}}</span>
                        <span v-if="data.user_manage_mobilephone">({{data.user_manage_mobilephone}})</span>
                    </div>
                </template>
            </c-table-column>

            <c-table-column
                    label="下单时间"
                    name="create_date"
                    width="150"
            >
            </c-table-column>

            <c-table-column
                    label="订单金额"
                    name="product_money"
                    width="120"
            >
                <template v-slot="{data}">
					<span v-if="data.order_type==2" style="color:#888888">
						{{data.product_money}}（积分）
					</span>
                    <span v-if="data.order_type==2 && data.logistics_money > 0" style="color:orangered">
						(另运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
					</span>
                    <span v-if="data.order_type!=2 && data.payment_state != 3" style="color:#888888">
						￥{{parseFloat(data.product_money+data.custom_money+data.logistics_money + data.total_fee_money).toFixed(2)}}
					</span>
                    <span v-if="data.order_type!=2 && data.payment_state == 3" style="color:darkgreen">
						￥{{parseFloat(data.payment_money).toFixed(2)}}
					</span>
                    <span v-if="data.order_type!=2 && data.logistics_money > 0" style="color:orangered">
						(含运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
					</span>
                    <span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
						<br/>(含服务费￥{{parseFloat(data.total_fee_money).toFixed(2)}})
					</span>
                    <span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
						<br/>(含定制费￥{{parseFloat(data.custom_money).toFixed(2)}})
					</span>
                </template>
            </c-table-column>
            <c-table-column
                    label="付款金额"
                    name="payment_money"
                    width="90"
            >
                <template v-slot="{data}">
						<span v-if="data.payment_money" style="color:darkgreen">
							￥{{parseFloat(data.payment_money).toFixed(2)}}
						</span>
                    <span v-else style="color:#bbbbbb" >--</span>
                </template>
            </c-table-column>

            <c-table-column
                    label="付款时间"
                    name="payment_date"
                    width="150"
            >
                <template v-slot="{data}">
						<span v-if="data.payment_date">
							{{data.payment_date}}
						</span>
                    <span v-else style="color:#bbbbbb" >--</span>
                </template>
            </c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
        props: {
          multiple: Boolean
        },
        data(){
            return {
                serachParams:{},
                orderState: [
                    {name: '待付款', value: 1},
                    {name: '待发货', value: 2},
                    {name: '待收货', value: 3},
                    {name: '交易完结', value: 5},
                    {name: '已关闭', value: 6}
                ],
                orderStateName: {
                    1: '待付款',
                    2: '待发货',
                    3: '待收货',
                    5: '交易完结',
                    6: '已关闭'
                }
            }
        },
        methods: {
          search(data) {
              data = Object.assign({}, data, this.serachParams);
              this.$refs.table.load({
                url: '/order/list',
                data
              });
          },
			
          open(params) {
                this.serachParams = params;
                this.$refs.form.clear();
                this.$refs.search.search();
                this.$refs.dialog.open();
          }
		}
	}
</script>